module.exports = __webpack_public_path__ + "media/packs/images/line-separator-68cb240dc83892dbfe9c06fa46a39a1f.svg";